<script>
import moment from "moment";

export default {
  locales: {
    pt: {
      'Monthly': 'Ativação',
      'Total Bonus': 'Total de Bônus',
      'Current Balance': 'Saldo Atual',
      'Graduation': 'Graduação',
      'No Graduation': 'Sem Graduação',
      'Points': 'Pontos',
      'ACTIVE': 'ATIVO',
      'INACTIVE': 'INATIVO',
    },
    es: {
      'Monthly': 'Ativação',
      'Total Bonus': 'Total de Bonus',
      'Current Balance': 'Saldo Actual',
      'Graduation': 'Graduación',
      'No Graduation': 'No Graduación',
      'Points': 'Puntos',
      'ACTIVE': 'ATIVO',
      'INACTIVE': 'INATIVO',
    }
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    month: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      month_year: moment().format("M/YYYY"),
    }
  }
};
</script>

<template>
  <div class="card" :class="color != '' ? 'bg-' + color : ' bg-white'">
    <div class="card-body p-3">
      <div v-if="type == 'line'" class="d-flex align-items-center">
        <div>
          <div class="bg-light rounded py-1 px-2">
            <i class="bx font-size-24 my-1 align-middle" :class="icon"></i>
          </div>
        </div>
        <div class="flex-fill ml-2">
          <h6 v-if="value == 'active'" class="mb-0 notranslate font-weight-bold"><span class="badge badge-soft-success px-2">{{ t('ACTIVE') }}</span></h6>
          <h6 v-else-if="value == 'inactive'" class="mb-0 notranslate font-weight-bold"><span class="badge badge-soft-danger px-2">{{ t('INACTIVE') }}</span></h6>
          <h5 v-else class="mb-0 notranslate font-weight-bold d-flex justify-content-between" v-html="t(value)"></h5>
          <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12" v-html="t(title)"></p>
        </div>
        <div v-if="month" class="text-right">
          <div class="font-size-11 mb- bg-soft-light rounded p-1">
            {{ month_year }}
          </div>
        </div>
      </div>
      <div v-else-if="type == 'center'" class="text-center align-items-center">
        <h5 v-if="value == 'active'" class="mb-0 notranslate font-weight-bold"><span class="badge badge-soft-success px-2">{{ t('ACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'inactive'" class="mb-0 notranslate font-weight-bold"><span class="badge badge-soft-danger px-2">{{ t('INACTIVE') }}</span></h5>
        <h5 v-else class="mb-0 notranslate font-weight-bold">{{ t(value) }}</h5>
        <p class="font-weight-medium mb-0 text-uppercase font-weight-light" v-html="t(title)"></p>
      </div>
      <div v-else class="d-flex justify-content-between align-items-center">
        <p class="font-weight-medium mb-0 text-uppercase font-weight-light" v-html="t(title)"></p>
        <h5 v-if="value == 'active'" class="mb-0 notranslate font-weight-bold"><span class="badge badge-soft-success px-2">{{ t('ACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'inactive'" class="mb-0 notranslate font-weight-bold"><span class="badge badge-soft-danger px-2">{{ t('INACTIVE') }}</span></h5>
        <h5 v-else class="mb-0 notranslate font-weight-bold">{{ t(value) }}</h5>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-success {
  background: #178961 !important;
  border: solid 1px #178961 !important;
  border-bottom: solid 2px #0d6244 !important;
  border-radius: 6px;
}
.bg-success .bg-light {
  background-color: var(--st-surface) !important;
}
.bg-success h5,
.bg-success p {
  color: #fff;
}

.bg-danger {
  border: solid 1px #EB1C24;
  border-bottom: solid 2px #a41419;
  border-radius: 6px;
}
.bg-danger .bg-light {
  background-color: var(--st-surface) !important;
}
.bg-danger h5,
.bg-danger p {
  color: #fff;
}

/* Os selos ATIVO/INATIVO deixaram de ser `bg-success + text-white`
   (2,27:1, reprovando ate o limiar de texto grande) e viraram
   `badge badge-soft-*`. Como o badge soft tem fundo translucido e este
   widget tambem pode ser renderizado dentro de um card colorido, dentro
   dessas variantes ele vira opaco e recupera a cor propria — senao herdaria
   o `color: #fff` das regras acima, que tem especificidade maior. */
.bg-success .badge,
.bg-danger .badge {
  background-color: var(--st-surface) !important;
}

.bg-success h5 .badge,
.bg-success h6 .badge {
  color: var(--st-success-strong) !important;
}

.bg-danger h5 .badge,
.bg-danger h6 .badge {
  color: var(--st-danger-strong) !important;
}
</style>